<template>
  <div class="activities">
    <div
      class="activity"
      v-for="t in timeline"
      :key="t.id"
    >
      <div
        class="activity-icon text-white shadow-primary"
        :class="{'bg-success': t.type === 'success', 'bg-warning': t.type === 'warning', 'bg-danger':t.type === 'danger'}"
      >
        <i
          class="fas"
          :class="{'fa-check':t.icon === 'check', 'fa-info':t.icon === 'info', 'fa-times':t.icon === 'times'}"
        />
      </div>
      <div class="activity-detail pl-0 pt-0">
        <div class="mb-2">
          <span class="text-job text-primary">
            {{ t.date }}
          </span>
        </div>
        <span class="text-job text-job-head">{{ t.text }}</span>
        <p>
          {{ t.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
    .activities .activity:before {
        background-color: #47c363;
    }
</style>

<script>
export default {
    data() {
        return {
            timeline: null
        }
    },
    computed: {
        dataPermohonan(){
            return this.$store.getters.getDataPermohonan
        },
        riwayatDataPermohonan(){
            return this.$store.getters.getRiwayatDataPermohonan
        }
    },
    methods: {
        createTimeline(){

            let ruleValidasi = this.dataPermohonan.paket_layanan

            let typeSuccess = [1, 5, 9, 14, 15, 16] // success karena valid / selesai

            let typeWarning = [0, 2, 3, 5, 6, 7, 9, 10, 11]

            let typeDanger = [4, 8, 12, 13]

            let riwayat = this.riwayatDataPermohonan
            let timeline = []

            let arrStatusRiwayat = []
            riwayat.forEach(e => {
                arrStatusRiwayat.push(e.status)
            })

            let maxStatus = Math.max.apply(null, arrStatusRiwayat)

            riwayat.forEach((e, i) => {
                let valTimestamp = 'timestamp_status_'+e.status

                let date = new Date(e[valTimestamp]).toLocaleDateString('id-ID', {year: 'numeric', month: 'short', day: 'numeric'}) + ' ' +e[valTimestamp].substr(11, 8)
                let type = 'success'
                let icon = 'check'
                
                if(typeSuccess.includes(e.status)){
                    type = 'success'
                    icon = 'check'
                } else if(typeWarning.includes(e.status)){
                    type = 'warning'
                    icon = 'info'
                    
                    if(e.status <= maxStatus){
                        type = 'success'
                        icon = 'check'
                    }
                } else if(typeDanger.includes(e.status)){
                    type = 'danger'
                    icon = 'times'
                    if(e.status <= maxStatus){
                        type = 'success'
                        icon = 'check'
                    }
                }

                let text = ''
                let content = ''
                switch(e.status){
                    case 0:
                        text = 'Draf Permohonan Dibuat'
                        if(e.user_pembantu){
                            content = `Dibuat oleh ${e.user_pembantu.penduduk.nama_lengkap}, NIK. ${e.user_pembantu.penduduk.nik}`
                        } else {
                            content = `Dibuat oleh ${e.penduduk.nama_lengkap}, NIK. ${e.penduduk.nik}`
                        }
                        
                        break
                    
                    case 1:
                        text = 'Permohonan Diajukan ke Desa'
                        content = `${(!e.keterangan_pemohon || e.keterangan_pemohon === 'null') ? '' : 'Keterangan: ' + e.keterangan_pemohon}`
                        break
                    
                    case 2:
                        text = 'Sedang Diproses oleh Desa'
                        content = `Diproses oleh ${e.user_proses_desa.penduduk.nama_lengkap}`
                        if(e.status <= this.dataPermohonan.status){
                            text = 'Diproses oleh Desa'
                        }
                        break
                    
                    case 3:
                        text = 'Perbaiki Permohonan (Revisi Tingkat Desa)'
                        content = `Dinyatakan perlu perbaikan oleh ${e.user_revisi_desa.penduduk.nama_lengkap}. ${(!e.keterangan_desa || e.keterangan_desa === 'null') ? '' : 'Keterangan: ' + e.keterangan_desa}`
                        break
                    
                    case 4:
                        text = 'Permohonan Ditolak Desa'
                        content = `Ditolak oleh ${e.user_tolak_desa.penduduk.nama_lengkap}. ${(!e.keterangan_desa || e.keterangan_desa === 'null') ? '' : 'Keterangan: ' + e.keterangan_desa}`
                        break
                    
                    case 5:
                        text = 'Valid tingkat Desa'
                        content = `Divalidasi oleh ${e.user_valid_desa.penduduk.nama_lengkap}. ${(!e.keterangan_desa || e.keterangan_desa === 'null') ? '' : 'Pesan dari Desa: ' + e.keterangan_desa}`
                        break
                    
                    case 6:
                        text = 'Sedang Diproses oleh Kecamatan'
                        content = `Diproses oleh ${e.user_proses_kecamatan.penduduk.nama_lengkap}`
                        if(e.status <= this.dataPermohonan.status){
                            text = 'Diproses oleh Kecamatan'
                        }
                        break
                    
                    case 7:
                        text = 'Perbaiki Permohonan (Revisi Tingkat Kecamatan)'
                        content = `Dinyatakan perlu perbaikan oleh ${e.user_revisi_kecamatan.penduduk.nama_lengkap}. ${(!e.keterangan_kecamatan || e.keterangan_kecamatan === 'null') ? '' : 'Keterangan: ' + e.keterangan_kecamatan}`
                        break
                    
                    case 8:
                        text = 'Permohonan Ditolak Kecamatan'
                        content = `Ditolak oleh ${e.user_tolak_kecamatan.penduduk.nama_lengkap}. ${(!e.keterangan_kecamatan || e.keterangan_kecamatan === 'null') ? '' : 'Keterangan: ' + e.keterangan_kecamatan}`
                        break
                    
                    case 9:
                        if(ruleValidasi.is_valid_kecamatan === 0 && ruleValidasi.is_valid_desa === 1){
                            text = 'Valid Tingkat Desa'
                            content = `Divalidasi oleh ${e.user_valid_desa.penduduk.nama_lengkap}. ${(!e.keterangan_desa || e.keterangan_desa === 'null') ? '' : 'Pesan dari Desa: ' + e.keterangan_desa}`
                        }
                        
                        if(ruleValidasi.is_valid_kecamatan === 1){
                            text = 'Valid Tingkat Kecamatan'
                            content = `Divalidasi oleh ${e.user_valid_kecamatan.penduduk.nama_lengkap}. ${(!e.keterangan_kecamatan || e.keterangan_kecamatan === 'null') ? '' : 'Pesan dari Kecamatan: ' + e.keterangan_kecamatan}`
                        }
                        
                        if(ruleValidasi.is_valid_kecamatan === 0 && ruleValidasi.is_valid_desa === 0){
                            text = 'Permohonan Dibuat'
                            content = `${(!e.keterangan_pemohon || e.keterangan_pemohon === 'null') ? '' : 'Keterangan: ' + e.keterangan_pemohon}`
                        }
                        
                        break
                    
                    case 10:
                        text = 'Sedang Diproses oleh Dukcapil'
                        content = `Diproses oleh ${e.user_proses_dukcapil.penduduk.nama_lengkap}`
                        if(e.status <= this.dataPermohonan.status){
                            text = 'Diproses oleh Dukcapil'
                        }
                        break
                    
                    case 11:
                        text = 'Perbaiki Permohonan (Revisi Tingkat Dukcapil)'
                        content = `Dinyatakan perlu perbaikan oleh ${e.user_revisi_dukcapil.penduduk.nama_lengkap}. ${(!e.keterangan_dukcapil || e.keterangan_dukcapil === 'null') ? '' : 'Keterangan: ' + e.keterangan_dukcapil}`
                        break
                    
                    case 12:
                        text = 'Permohonan Ditolak Dukcapil'
                        content = `Ditolak oleh ${e.user_tolak_dukcapil.penduduk.nama_lengkap}. ${(!e.keterangan_dukcapil || e.keterangan_dukcapil === 'null') ? '' : 'Keterangan: ' + e.keterangan_dukcapil}`
                        break
                    
                    case 13:
                        text = 'Permohonan Dibatalkan'
                        content = ''
                        break
                    
                    case 14:
                        text = 'Permohonan Valid Tingkat Dukcapil'
                        content = `Divalidasi oleh ${e.user_valid_dukcapil.penduduk.nama_lengkap}. ${(!e.keterangan_dukcapil || e.keterangan_dukcapil === 'null') ? '' : 'Pesan dari Dukcapil: ' + e.keterangan_dukcapil}`
                        break
                    
                    case 15:
                        text = 'Berkas Siap Diambil'
                        content = 'Dukcapil telah upload berkas hasil permohonan anda'
                        break
                    
                    case 16:
                        text = 'Selesai'
                        content = 'Permohonan anda telah dinyatakan Selesai'
                        break
                }


                timeline.push({
                    id: i,
                    type: type,
                    icon: icon,
                    date: date,
                    text: text,
                    content: content
                })

                
            })
            
            switch(this.dataPermohonan.status){
                case 1:
                    timeline.push({
                        id: +new Date(),
                        type: 'warning',
                        icon: 'info',
                        date: '',
                        text: 'Menunggu Konfirmasi Desa',
                        content: ''
                    })
                    break
                
                case 5:
                    timeline.push({
                        id: +new Date(),
                        type: 'warning',
                        icon: 'info',
                        date: '',
                        text: 'Diajukan ke Tingkat Kecamatan',
                        content: ''
                    })
                    break

                case 9:
                    timeline.push({
                        id: +new Date(),
                        type: 'warning',
                        icon: 'info',
                        date: '',
                        text: 'Diajukan ke Tingkat Dukcapil',
                        content: ''
                    })
                    break

                case 14:
                    timeline.push({
                        id: +new Date(),
                        type: 'warning',
                        icon: 'info',
                        date: '',
                        text: 'Menunggu Berkas Yang Dimohonkan',
                        content: ''
                    })
                    break

                case 15:
                    timeline.push({
                        id: +new Date(),
                        type: 'warning',
                        icon: 'info',
                        date: '',
                        text: 'Menunggu Berkas Diambil Oleh Pemohon',
                        content: ''
                    })
                    break
            }
            

            this.timeline = timeline
        },
    },
    created(){
        if(this.riwayatDataPermohonan){
            this.createTimeline()
        }
    },
    watch: {
        riwayatDataPermohonan(newVal){
            this.createTimeline()
        }
    }
}
</script>